var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "de-button",
      class: [
        _vm.type ? "de-button--" + _vm.type : "",
        {
          "is-de-plain": _vm.plain,
          "is-de-secondary": _vm.secondary,
          "is-de-disabled": _vm.buttonDisabled,
          "is-de-loading": _vm.loading,
        },
      ],
      attrs: { type: "button", disabled: _vm.buttonDisabled || _vm.loading },
      on: { click: _vm.handleClick },
    },
    [
      _vm.loading
        ? _c(
            "svg",
            { staticClass: "de-circular", attrs: { viewBox: "25 25 50 50" } },
            [
              _c("circle", {
                staticClass: "path",
                attrs: { cx: "50", cy: "50", r: "20", fill: "none" },
              }),
            ]
          )
        : _vm._e(),
      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
      _vm.$slots.default
        ? _c(
            "span",
            { class: [{ "de-btn-mar5": _vm.icon || _vm.loading }] },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }